import { timeAgo } from '../lib/timeAgo';
import type { Kid } from '../types';

interface Props {
  kid: Kid;
}

export function StatusPanel({ kid }: Props) {
  const label = kid.available ? 'Can play' : 'Not right now';
  const updated = timeAgo(kid.updated_at);

  return (
    <section
      aria-label={`${kid.name}: ${label.toLowerCase()}. Updated ${updated}.`}
      className={[
        'grid place-items-center overflow-hidden p-3 text-center transition-colors duration-200',
        // Safe-area padding keeps content clear of a notch or home indicator.
        'first:pt-[max(0.75rem,env(safe-area-inset-top))]',
        'last:pb-[max(0.75rem,env(safe-area-inset-bottom))]',
        'sm:landscape:first:pt-3 sm:landscape:last:pb-3',
        kid.available
          ? 'bg-linear-150 from-play-light to-play text-play-ink'
          : 'bg-linear-150 from-busy-light to-busy text-busy-ink',
      ].join(' ')}
    >
      <div className="flex max-w-full flex-col items-center gap-1 sm:gap-2">
        <p className="m-0 text-[clamp(2.25rem,11vmin,6rem)] leading-none font-semibold tracking-tight">
          {kid.name}
        </p>

        {/* Colour carries the message at a glance; the words carry it for
            anyone who cannot separate red from green. */}
        <p className="m-0 flex items-center gap-2 text-[clamp(0.95rem,3.1vmin,1.6rem)] font-medium opacity-90">
          <span aria-hidden="true" className="size-[0.62em] shrink-0 rounded-full bg-current opacity-85" />
          {label}
        </p>

        <time
          dateTime={kid.updated_at}
          className="m-0 text-[clamp(0.7rem,1.9vmin,0.95rem)] tabular-nums opacity-60"
        >
          Updated {updated}
        </time>
      </div>
    </section>
  );
}
